import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/LoginForm';
import FIPlogo from '../assets/FIPlogo.svg';

const LoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    const userDetails = JSON.parse(localStorage.getItem('token'));
    // console.log(userDetails.result.role)
    // let token = userDetails ? userDetails.result.token : null;
    if (token) {
      if(['ADMIN', 'SUPER_USER', 'RBM', 'ABM', 'REPRESENTATIVE'].includes(userDetails.result.role)){
        navigate('/home')
      }else{
      navigate('/fileuploaddetails');
      }// Redirect to dashboard if token exists
    }
  }, [navigate]);

  return (
    <div className='flex w-full h-screen bg-[#00dac4]'>
      <div className='hidden flex-col relative lg:flex h-full w-1/2 items-center justify-center  bg-teal-200'>
        <div className='w-80 h-80 bg-gradient-to-tr from-[#00dac4] to-[#c0f0e2] rounded-full animate-bounce'>
          <img src={FIPlogo} alt='logo' className='w-60 h-60 ml-10 mt-4' />
        </div>
        <div className='w-full h-1/2 absolute bottom-0  backdrop-blur-md' />
      </div>
      <div className='w-full flex items-center justify-center lg:w-1/2'>
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;